import { api } from 'utility';
import { fileDownloader } from 'utility/util';
import {
  getGenerateApiKeyUrl,
  getReportTotalRequestedSeviceCallUrl,
  getReportRequestedServiceUrl,
  getExportReportRequestedServiceUrl,
  getReportNumber1499Url,
  getExportReportNumber1499Url,
} from 'URLs';
export function requestedServiceSetApi(data, params) {
  return api.post(getReportNumber1499Url(), data, { params }).then((res) => res.data);
}
export function requestedServiceSetApiExport(data, params, type, onError) {
  return fileDownloader(
    'POST',
    getExportReportNumber1499Url(type),
    params,
    data,
    null,
    type,
    null,
    onError,
  );
}

export function getRequestedServicesApi(data, params) {
  return api.post(getReportRequestedServiceUrl(), data, { params }).then((res) => res.data);
}

export function getRequestedServicesApiExport(data, params, type) {
  return fileDownloader('POST', getExportReportRequestedServiceUrl(type), params, data, null, type);
}

export function getTotalRequestedServiceCalls(id) {
  return api.get(getReportTotalRequestedSeviceCallUrl(id)).then((res) => res.data);
}

export function generateApiKeyApi(data, serviceId) {
  return api.get(getGenerateApiKeyUrl(serviceId), data).then((res) => res.data);
}

export function deleteApiKeyApi(params, requestId) {
  return api.delete(getGenerateApiKeyUrl(requestId), { params }).then((res) => res.data);
}
